import React from 'react';
import { useIntl } from 'react-intl';

import { ModalContext } from '@notino/react-styleguide-v20';

import { useApplicationRuntimeContext } from '@context/ApplicationRuntimeContext';
import { IGeneralProductItem, ProductItemBodyWrapper } from '@sharedComponents/Products/';
import { MODAL_SETTINGS_DEFAULT } from '@utils/constants';
import { CypressTestNamespace } from '@utils/test';

import { useCartPageContext } from '../../../context';
import { messages as generalMessages } from '../../../messages';
import { IDiscoveryBox } from '../../../model';
import { DiscoveryBoxModalBody } from '../../DiscoveryBoxModalBody';

import { messages } from './discoveryBoxMessages';

const DISCOVERY_BOX_MAXIMUM_QUANTITY = 1;
const DISCOVERY_BOX_ITEM_QUANTITY = 1;

export const useDiscoveryBoxProduct = (): IGeneralProductItem[] => {
  const { formatMessage } = useIntl();
  const {
    applicationSettings: { secondaryCurrency },
  } = useApplicationRuntimeContext();

  const isDualPriceLayout = Boolean(secondaryCurrency);

  const {
    actions: { removeDiscoveryBox },
    state: {
      serviceItems: { discoveryBox: discoveryBoxes },
    },
    settings: { discoveryBox: discoveryBoxSettings },
  } = useCartPageContext();

  const { toggleModal, hideModal } = ModalContext.useModalContext();

  return discoveryBoxes.map((discoveryBox: IDiscoveryBox): IGeneralProductItem => {
    return {
      key: `${discoveryBox.itemId}-discoveryBox`,
      isDualPriceLayout: isDualPriceLayout,
      dataTestId: CypressTestNamespace.ECartPageProducts.PRODUCT_WRAPPER,
      itemQuantity: DISCOVERY_BOX_ITEM_QUANTITY,
      maximumQuantity: DISCOVERY_BOX_MAXIMUM_QUANTITY,
      price: discoveryBox.priceWithVat,
      disabled: !discoveryBox.allProductsAvailable,
      ...(discoveryBoxSettings.image && { imageUrl: discoveryBoxSettings.image }),
      textContent: (
        <ProductItemBodyWrapper
          brand={formatMessage(messages.discoveryBoxBrand)}
          name={formatMessage(messages.discoveryBoxName)}
          subName={formatMessage(messages.discoveryBoxSubName)}
          disabled={!discoveryBox.allProductsAvailable}
          maximumQuantity={DISCOVERY_BOX_MAXIMUM_QUANTITY}
          itemQuantity={DISCOVERY_BOX_ITEM_QUANTITY}
          messages={messages}
          onClick={() => {
            toggleModal(<DiscoveryBoxModalBody itemId={discoveryBox.itemId} products={discoveryBox.products} />, {
              ...MODAL_SETTINGS_DEFAULT,
              onClose: hideModal,
            });
          }}
        />
      ),
      unit: formatMessage(generalMessages.pieceUnit),
      quantityCounterDisabled: true,
      deleteButtonClick: () => removeDiscoveryBox(discoveryBox.itemId, discoveryBox),
      buttonTextContextHelp: formatMessage(generalMessages.removeProductTitle),
      buttonText: formatMessage(generalMessages.removeProductButton),
    };
  });
};
